import { AUTH_DATA } from "./authData";

/** Typy wydarzeń prywatnych (widoczne tylko dla autora). Reszta = publiczne. */
export const PRIVATE_EVENT_TYPES = ["medical", "consulting"];

type RoleMapLike = { role?: { role?: string | null } | null } | null;
export type UserLike =
  | { id?: number; roles?: RoleMapLike[] | null }
  | null
  | undefined;
export type EventLike =
  | { type?: string | null; user?: { id?: number } | null }
  | null
  | undefined;

export const getRoleCodes = (user: UserLike): string[] =>
  (user?.roles ?? [])
    .map((roleMap) => roleMap?.role?.role ?? "")
    .filter((code) => code !== "");

export const hasAnyRole = (user: UserLike, allowed: string[]): boolean => {
  const codes = getRoleCodes(user);
  return allowed.some((code) => codes.includes(code));
};

export const isAdminUser = (user: UserLike): boolean =>
  hasAnyRole(user, AUTH_DATA.ADMIN_ROLES);

export const isEditorUser = (user: UserLike): boolean =>
  hasAnyRole(user, AUTH_DATA.EDITOR);

/** Admin i Redaktor mogą tworzyć/edytować wydarzenia publiczne. */
export const canManagePublicEvents = (user: UserLike): boolean =>
  isAdminUser(user) || isEditorUser(user);

export const isPrivateEventType = (type?: string | null): boolean =>
  !!type && PRIVATE_EVENT_TYPES.includes(type);

/**
 * Czy user może edytować/usunąć DANE wydarzenie niezależnie od własności.
 * Własne prywatne wydarzenia obsługuje osobno flaga `isPrivate` w EventTemplate.
 */
export const canManageEvent = (user: UserLike, event: EventLike): boolean => {
  if (isAdminUser(user)) {
    return true;
  }
  return isEditorUser(user) && !isPrivateEventType(event?.type);
};
